export enum StartupSteps {
    WELCOME = 0,
    WHO,
    WHOELSE,
    MEET_YOUR_PLAN,
    INCOMES,
    EXPENSES,
    CASH_AND_BANKING,
    SAVINGS,
    RETIREMENT,
    LOANS_AND_DEBTS,
    PROPERTY_AND_ASSETS,
    PROPERTY,
    SAVE,
    DONE,
    CONNECT = 100
}

export const OTHER_INCOME = 'Other income';
export const ANONYMOUS_NAME = 'Anonymouse User';
export const PRIMARY_BUTTON_SELECTOR = '.primaryButton';
